import Box from '@mui/material/Box';

import banner from '@/assets/og-logo.svg?raw';

import Avatar from './Avatar';
import { styles } from './style';

const Header = () => (
    <Box sx={styles.layout}>
        <Box sx={styles.avatarSocket}>
            <Avatar/>
        </Box>
        <Box sx={styles.bannerSocket}>
            <Box sx={styles.banner} dangerouslySetInnerHTML={{ __html: banner }}/>
        </Box>
    </Box>
);

export default Header;
